import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Build Run Time ")

import { IncrediCard, IncrediChartHeatmap } from 'incredi-ui';
import IbxScopedCss from '@/components/IbxScopedCss/IbxScopedCss.vue';
import DashboardChartTitle from '@/views/dashboard/components/dashboard-chart-title.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'workload-duration-by-hours-chart',
  props: {
    chartOptions: null
  },
  setup(__props: any) {



const tooltip = [
  {
    description: ['The total duration of each build during the highlighted time period.', 'If more than one week is displayed, the average of each day is used.'],
  },
];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(IbxScopedCss, null, {
    default: _withCtx(() => [
      _createVNode(_unref(IncrediCard), { class: "relative h-full p-[16px] !shadow-none border border-Border/border_natural" }, {
        default: _withCtx(() => [
          _createVNode(DashboardChartTitle, {
            absolute: "",
            tooltip: tooltip
          }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          }),
          _createVNode(_unref(IncrediChartHeatmap), _mergeProps({ height: "284px" }, __props.chartOptions), null, 16)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})